// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1248":"css/admin-app.6932","7367":"css/app.6932"}[chunkId] + ".css";
};